import React from 'react';

export interface Props {
  name: string;
  children?: React.ReactNode;
}

export const Variant: React.FC<Props> = ({ children }) => (
  <React.Fragment>{children}</React.Fragment>
);
